import { render } from "./newHostModal.vue?vue&type=template&id=af5d2ca8"
import script from "./newHostModal.vue?vue&type=script&lang=js"
export * from "./newHostModal.vue?vue&type=script&lang=js"
script.render = render

export default script